import axios from "axios";
import swal from "sweetalert2";

// const apiUrl = "http://local-explus-backend.test/api"
// const apiUrl = "https://explusmobile.worldvision.org.ph/explus-mobile/developer/laravel-backend/public/api";
// const apiUrl = 'https://explusmobile.worldvision.org.ph/explus-mobile/developer/laravel-backend-uat/public/api'

const apiUrl = process.env.REACT_APP_API_URL;

let token = "";

if (localStorage.getItem("token")) {
    token = localStorage.getItem("token");
}

const config = {
    headers: { Authorization: "Bearer " + token },
    withCredentials: true
};

const expiredTokenRedirect = error => {
    if (!error.response) {
        return;
    }

    const statusCode = error.response.status;

    //error.response.status
    if (statusCode === 401) {
        if (localStorage.getItem("token")) {
            localStorage.removeItem("token");
            localStorage.clear();
            sessionStorage.clear();

            window.location.href = "/login";
        }
    }
};

const requestGet = url => {
    const config = {
        // headers: {'Authorization': "VBearer" + token},
        "Cache-Control": "no-store, no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        withCredentials: false
    };

    return axios
        .get(url, config)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            expiredTokenRedirect(error);

            let err = { status: "error", message: "network error" };

            if (typeof error.response !== "undefined") {
                err.message = error.response.data.message;
            }

            return err;
        });
};

// expiredTokenRedirect(error.response.status)

const getAppUrl = () => {
    return apiUrl;
}

const ajaxGet = (endPoint, value) => {
    let resourceUrl = apiUrl + "/" + endPoint;
    let parameter = "";

    // if value is number turn it to page number
    // else accept a url
    if (typeof value === "number") {
        parameter = "?page=" + value;
    } else if (typeof value === "string" && value !== "") {
        resourceUrl = value;
    }

    return axios
        .get(resourceUrl + parameter, config)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            expiredTokenRedirect(error);

            let err = { status: "error", message: "network error" };

            if (typeof error.response !== "undefined") {
                err.message = error.response.data.message;
            }

            return err;
        });
};

const ajaxPhone = (endPoint, parameter) => {
    let resourceUrl = apiUrl + "/" + endPoint;

    return axios
        .get(resourceUrl + parameter, config)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            expiredTokenRedirect(error);

            let err = { status: "error", message: "network error" };

            if (typeof error.response !== "undefined") {
                err.message = error.response.data.error;
            }

            return err;
        });
};

const requestPost = (endPoint, postdata) => {
    let resourceUrl = apiUrl + "/" + endPoint;

    return axios
        .post(resourceUrl, postdata, config)
        .then(response => {
            return response;
        })
        .catch(error => {
            expiredTokenRedirect(error);

            let err = { status: "error", message: "network error" };

            if (error.response !== undefined) {
                if (error.response.data.message !== undefined) {
                    err = error.response.data.message;
                } else if (typeof error.response.data.error === "object") {
                    err = error.response.data.error;
                    const errMessage = [];

                    for (var ele in err) {
                        for (var index = 0; index < err[ele].length; index++) {
                            errMessage.push(err[ele][index]);
                        }
                    }

                    return swal.fire("Error", errMessage.join("<br/>"), "error");
                } else {
                    return swal.fire("Error", error.response.data.error, "error");
                }
            }

            return swal.fire("Error", error.message, "error");
        });
};

const ajaxPost = (endPoint, postdata) => {
    let resourceUrl = apiUrl + "/" + endPoint;

    return axios
        .post(resourceUrl, postdata, config)
        .then(response => {
            // return alert('success')
            return swal.fire("Saved", "Your details has been updated.", "success");
        })
        .catch(error => {
            expiredTokenRedirect(error);

            let err = { status: "error", message: "network error" };

            if (error.response !== undefined) {
                if (error.response.data.message !== undefined) {
                    err = error.response.data.message;
                } else if (typeof error.response.data.error === "object") {
                    err = error.response.data.error;
                    const errMessage = [];

                    for (var ele in err) {
                        for (var index = 0; index < err[ele].length; index++) {
                            errMessage.push(err[ele][index]);
                        }
                    }

                    return swal.fire("Error", errMessage.join("<br/>"), "error");
                } else {
                    return swal.fire("Error", error.response.data.error, "error");
                }
            }

            return swal.fire("Error", error.message, "error");
        });
};

const ajaxLogin = (endPoint, postdata) => {
    let resourceUrl = apiUrl + "/" + endPoint;

    return axios
        .post(resourceUrl, postdata)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            //      console.log(error.headers['set-cookie']);
            //  expiredTokenRedirect(error.response.status)
            let err = { status: "error", message: "network error" };

            if (typeof error.response !== "undefined") {
                err = { status: "error", message: error.response.data.message };
            }

            return err;
        });
};

export { ajaxGet, ajaxPost, requestPost, ajaxLogin };

//Custom Modules
const Login = postdata => {
    // const apiUrl = 'https://explusmobile.worldvision.org.ph/explus-mobile/developer/laravel-backend-uat/public/api'
    let loginApiUrl = apiUrl;
    // let loginApiUrl = 'https://explusmobile.worldvision.org.ph/explus-mobile/developer/laravel-backend/public/api'
    // let resourceUrl = apiUrl + '/authenticate'
    let resourceUrl = loginApiUrl + "/user_login";

    return axios
        .post(resourceUrl, postdata)
        .then(response => {
            response = response.data;
            localStorage.setItem("token", response.token);
            localStorage.setItem("myspon_donate_token", response?.myspon_donate_token);
            localStorage.setItem("userId", response.user.id);
            localStorage.setItem("permissions", response.user.permissions);

            swal.fire("Login", "Log in Successful", "success").then(result => {
                if(postdata['refer']=='ambassador'){
                    window.location = "/dashboard/ambassador";
                }else{
                    window.location = "/";
                }
                
            });

            return response.data;
        })
        .catch(error => {
            if (error.response) {
                if (error.response.status === 403) {
                    return swal.fire(
                        "Forbidden",
                        error.response.data.message,
                        "error"
                    );
                }
            }

            // console.log(error.response);
            return swal.fire(
                "Invalid Login",
                "Username or password is incorrect",
                "error"
            );
            // return error;
        });
};

// Reset Password
const ResetPassword = postdata => {
    const url = apiUrl + "/password/reset";

    return axios.post(url, postdata).then(
        response => {
            swal.fire("Password reset", "Success", "success").then(() => {
                window.location = "/login";
            });

            return response.data;
        },
        error => {
            // Network error
            swal.fire(
                "Network error",
                "Please check if you are properly connected to the internet",
                "error"
            );

            // const error = res.data;
            // console.log('Error----------> ', error.response.data)
            const err = error.response;
            let message = "Error";
            let messageType = "Error";

            if (error && err.data) {
                let validationErrors = [];
                let result = [];

                if (err.data.validation) {
                    messageType = "Input Error";
                    result = err.data.validation;

                    validationErrors = Object.keys(result).map(function(
                        key,
                        index
                    ) {
                        return result[key].join("<br />");
                    });
                } else if (err.data.error) {
                    if (err.data.error === "passwords.token") {
                        messageType = "Password reset token has expired";
                        validationErrors.push("Please request a new one.");
                    }
                }

                message = validationErrors.join("<br />");
            }

            swal.fire(messageType, message, "error");

            return Promise.reject("Error");
        }
    );
};

// Get child by ID
const getChildById = childId => {
    let resourceUrl = apiUrl + "/web/children";
    let parameter = "";

    if (childId) {
        parameter = "?child_id=" + childId;
    }

    return axios
        .get(resourceUrl + parameter, config)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            expiredTokenRedirect(error);
            swal.fire("Error", "Error fetching data", "error");
            return error;
        });
};

//Partners
const getPartner = () => {
    let resourceUrl = apiUrl + "/web/partners";

    return axios
        .get(resourceUrl, config)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            expiredTokenRedirect(error);
            swal.fire("Error", "Error fetching data", "error");
            return error;
        });
};

//Get child video
const getChildVideo = childId => {
    let resourceUrl = apiUrl + "/v2/child/video";

    if (childId) {
        resourceUrl = apiUrl + "/v2/child/video/" + childId;
    }

    return axios
        .get(resourceUrl, config)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return { status: "error" };
            // expiredTokenRedirect(error)
            // swal.fire(
            //   'Error',
            //   'Error fetching data',
            //   'error'
            // )
            // return error;
        });
};


//Get CUV video
const getChildVideoSolo = childId => {
    let resourceUrl = apiUrl + "/web/v3/get_cuv_v2";

    if (childId) {
        resourceUrl = apiUrl + "/web/v3/get_cuv_v2?child_id=" + childId;
    }

    return axios
        .get(resourceUrl, config)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return { status: "error" };
            // expiredTokenRedirect(error)
            // swal.fire(
            //   'Error',
            //   'Error fetching data',
            //   'error'
            // )
            // return error;
        });
};

//Upload Receipts
const uploadReceipt = formData => {
    let resourceUrl = apiUrl + "/web/uploaddeposit";
    return axios
        .post(resourceUrl, formData, config)
        .then(response => {
            swal.fire("Success", "Successfully Uploaded Receipt", "success");
            return response.data;
        })
        .catch(error => {
            expiredTokenRedirect(error);
            let uploadErr = "Error in uploading";
            if (error.response.data.error === undefined) {
            } else {
                uploadErr = error.response.data.error;
            }
            swal.fire("Error", uploadErr, "error");
            return error;
        });
};

//Email Child
const emailChild = formData => {
    let resourceUrl = apiUrl + "/web/sendletter";
    return axios
        .post(resourceUrl, formData, config)
        .then(response => {
            swal.fire("Success", "Successfully Submitted Letter", "success");

            return response.data;
        })
        .catch(error => {
            expiredTokenRedirect(error);

            errorResponse(error, "validation");
        });
};

const errorResponse = (error, bagName = "error") => {
    let err = { status: "error", message: "network error" };

    if (
        error.response !== undefined &&
        typeof error.response.data[bagName] === "object"
    ) {
        err = error.response.data[bagName];
        const errMessage = [];

        for (var ele in err) {
            for (var index = 0; index < err[ele].length; index++) {
                errMessage.push(err[ele][index]);
            }
        }

        return swal.fire("Error", errMessage.join("<br/>"), "error");
    } else {
        return swal.fire("Error", err.message, "error");
    }
};

//Spon Visit
const sponVisit = formData => {
    let resourceUrl = apiUrl + "/web/sponvisit";
    return axios
        .post(resourceUrl, formData, config)
        .then(response => {
            swal.fire("Success", "Successfully Submitted Sponsor Visit", "success");
            return response.data;
        })
        .catch(error => {
            expiredTokenRedirect(error);

            let uploadErr = "Error in sponsor visit";
            if (error.response.data.error === undefined) {
            } else {
                uploadErr = error.response.data.error;
            }
            swal.fire("Error", uploadErr, "error");
            return error;
        });
};

//Amabassador
const ambassador = formData => {
    let resourceUrl = apiUrl + "/web/insert-ambassador";
    return axios
        .post(resourceUrl, formData, config)
        .then(response => {
            swal.fire("Success", "Successfully Registered as Ambassador.<br />Thank you for registering! We'll get back to you within 1-3 business days.", "success");
            return response.data;
        })
        .catch(error => {
            expiredTokenRedirect(error);

            let uploadErr = "Error in Submitting";
            if (error.response.data.error === undefined) {
            } else {
                uploadErr = error.response.data.error;
            }
            swal.fire("Error", uploadErr, "error");
            return error;
        });
};

//Contact Us
const contactUs = formData => {
    let resourceUrl = apiUrl + "/web/contactus";
    return axios
        .post(resourceUrl, formData, config)
        .then(response => {
            swal.fire("Success", "Successfully Submitted Message<br />We will get back to you within 24-48 hours.", "success");
            return response.data;
        })
        .catch(error => {
            expiredTokenRedirect(error);

            let uploadErr = "Error in Submitting";
            if (error.response.data.error === undefined) {
            } else {
                uploadErr = error.response.data.error;
            }
            swal.fire("Error", uploadErr, "error");
            return error;
        });
};

//Change password
const changePassword = formData => {
    let resourceUrl = apiUrl + "/password/email";

    return axios
        .post(resourceUrl, formData, config)
        .then(response => {
            let subject = "Email sent";
            let message =
                "Please check your email for instructions. You will only receive email if there is a valid account associated with the email address you entered.";

            swal.fire(subject, message, "success");
            return response.data;
        })
        .catch(error => {
            expiredTokenRedirect(error);

            let message = "Invalid Email";

            swal.fire("Error", message, "error");
            return error;
        });
};

// Rating 2022
const saveRating = (post_data) => {
    let resourceUrl = apiUrl + "/rating";

    return axios
    .post(resourceUrl, post_data, config)
        .then(response => {
            return response.data;
        })
        .catch(e => {
            return e.response.data;
        });
};

// Download video 2022
const downloadVideo = childId => {
    let resourceUrl = apiUrl + "/web/v3/download_cuv/" + childId;

    return axios
    .get(resourceUrl, config)
        .then(response => {
            return response.data;
        })
        .catch(e => {
            return 'error'
        });
};

// expiredTokenRedirect(error.response.status)

const getPermits = (endPoint, value) => {
    let resourceUrl = 'https://event-api.worldvision.org.ph/api/public/get-options?module=general&only=dswd';

    return axios
    .get(resourceUrl)
        .then(response => {
            return response.data;
        })
        .catch(e => {
            return 'error'
        });
};

const WebService = {
    getChildVideo,
    getChildVideoSolo,
    requestGet,
    requestPost,
    ResetPassword,
    changePassword,
    saveRating,
    downloadVideo,
    getAppUrl,
    ajaxGet: ajaxGet,
    ajaxPost: ajaxPost,
    ajaxLogin: ajaxLogin,
    Login: Login,
    getChildById: getChildById,
    getPartner: getPartner,
    uploadReceipt: uploadReceipt,
    emailChild: emailChild,
    sponVisit: sponVisit,
    contactUs: contactUs,
    ambassador: ambassador,
    ajaxPhone: ajaxPhone,
    getPermits: getPermits,
};

export default WebService;
